import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';

export default function createAppStore(preloadedState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    devTools: process.env.NODE_ENV !== 'production',
  });
}
